import { render, staticRenderFns } from "./Multitenant.vue?vue&type=template&id=1577652a&scoped=true&"
import script from "./Multitenant.vue?vue&type=script&lang=js&"
export * from "./Multitenant.vue?vue&type=script&lang=js&"
import style0 from "./Multitenant.vue?vue&type=style&index=0&id=1577652a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577652a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VContainer})
